export const SITE = {
  name: "Edil Murgia",
  tagline: "Impresa edile a Genova dal 1984",
  logo:
    "https://lirp.cdn-website.com/379e07d9/dms3rep/multi/opt/0WOSX000004ridL4AQ_edil-murgia-lgoo-423e2c28-207w.png",
  phones: ["+39 380 5911814", "+39 329 0030105"],
  email: "albertomurgia8@gmail.com",
  address: "Via Ravel Maurice, 50/10 - 16159 GENOVA (GE)",
  vat: "P.I. 02835680998",
  hours: "Lun-Ven 9:00 - 17:00 · Sab-Dom chiuso",
  whatsapp: "https://wa.me/393805911814",
};

export const SERVICES = [
  {
    key: "tinteggiatura",
    title: "Tinteggiatura e Imbiancatura",
    desc: "Pareti interne ed esterne con finiture professionali, decorative e idrorepellenti.",
    icon: "PaintRoller",
  },
  {
    key: "cartongesso",
    title: "Cartongesso e Tramezzature",
    desc: "Pareti, controsoffitti e nicchie su misura per modulare gli spazi.",
    icon: "LayoutPanelTop",
  },
  {
    key: "pavimenti",
    title: "Pavimenti e Rivestimenti",
    desc: "Posa di parquet, gres, ceramica e mosaico con cura artigianale.",
    icon: "Grid2x2",
  },
  {
    key: "tetti",
    title: "Tetti e Cappotto Termico",
    desc: "Coperture, isolamento termico esterno e risparmio energetico.",
    icon: "Home",
  },
  {
    key: "terrazzi",
    title: "Realizzazione Terrazzi",
    desc: "Impermeabilizzazione, pavimentazione e ringhiere per terrazzi sicuri e belli.",
    icon: "Sun",
  },
  {
    key: "impianti",
    title: "Impianti Elettrici e Idraulici",
    desc: "Progettazione e realizzazione di impianti a norma chiavi in mano.",
    icon: "Plug",
  },
];

export const PROJECTS = [
  {
    title: "Cucina rinnovata - Sampierdarena",
    before:
      "https://images.unsplash.com/photo-1765277789236-18b14cb7869f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    after:
      "https://images.unsplash.com/photo-1755316388093-faff473ffdfb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Soggiorno - Albaro",
    before:
      "https://images.pexels.com/photos/1571463/pexels-photo-1571463.jpeg?auto=compress&cs=tinysrgb&w=1400",
    after:
      "https://images.pexels.com/photos/34277650/pexels-photo-34277650.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    title: "Open space - Nervi",
    before:
      "https://images.pexels.com/photos/2724748/pexels-photo-2724748.jpeg?auto=compress&cs=tinysrgb&w=1400",
    after:
      "https://images.pexels.com/photos/13201479/pexels-photo-13201479.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
];
